export default __webpack_public_path__ + "static/expert_on_the_way_identity-b6c89f4860963a94fcce31e181217309.svg";